export function imageLoader(url: string) {
  return new Promise<HTMLImageElement>((resolve) => {
    const image = new Image
    image.crossOrigin = 'anonymous'
    image.src = url
    image.onload = () => {
      resolve(image)
    }
  })
}